/* eslint-disable import/order, import/no-extraneous-dependencies, @typescript-eslint/no-unused-vars */ /* eslint-enable import/order, import/no-extraneous-dependencies, @typescript-eslint/no-unused-vars */ import useCookie from '@haaretz/s-atoms/cookie';
import clearCookie from '@haaretz/s-cookie-utils/clearCookie';
import * as React from 'react';
const defaultMessage = {
    messageType: '',
    title: '',
    instructions: '',
    action: 0,
    ctaType: 'link',
    cta: 'Back to homepage',
    link: 'https://www.haaretz.com'
};
const COOKIE_NAME = 'promotions-response-message';
export default function usePPMessage() {
    const cookie = useCookie('serverValue');
    const ppMessage = cookie.ppResponseMessage;
    React.useEffect(()=>{
        if (ppMessage) {
            clearCookie(COOKIE_NAME);
        }
    }, [
        ppMessage
    ]);
    if (ppMessage) return ppMessage;
    return defaultMessage;
}
usePPMessage.cookieName = COOKIE_NAME;

//# sourceMappingURL=usePPMessage.js.map